<template>
    <div class="row top-stick-bar">
        <div class="top-stick-bar-in">		
            <div class="col-md-2 left-align">			
            </div>
            <div class=" right-align rtl-sup-font">
                <translate-page v-if="themelogic.additional_flag.google_language_select && id_language=='053'"></translate-page>                    
            </div>
            <div class=" right-align rtl-sup-font">   
                <!-- <transform-fonts></transform-fonts> -->
            </div>
            
        </div>
    </div>
</template>

<script>
import TransformFonts from '@/components/ThemeCosmic/pages/partialsCommon/TransformFonts';
import TranslatePage from '@/components/ThemeCosmic/pages/partialsCommon/TranslatePage';
export default {
    name: 'TopStickBar',
    data(){
        return{
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            id_language:this.$store.state.companyData['id_language']     
        };
        
    },
    computed:{
       languageData(){return this.$store.state.languageData;},
       themelogic(){return this.$store.state.themeLogic;}
    },
	components:{
        TransformFonts,
        TranslatePage
    }
};
</script>
<style scoped>
.top-stick-bar{
    border-bottom: 1px solid #e6e6e63d;
    padding: 1px 0;
}
.top-stick-bar-in{
    margin: auto;
    width:68%;
    max-width: 1280px;
}
.right-align{
    float: right ;
    text-align: right ;
    padding-right: 0px;
    padding-left: 15px;
}
.left-align{
    float: left ;
}
@media only screen and (max-width: 575px) {
    .top-stick-bar-in{
        width:86%;
    }
}
</style>